import http from "./../services/httpService";


export async function getClients() {
    const resp = await http.get(`/clients/`)
    return resp.data
}

export async function getClient(id) {
    const resp = await http.get(`/clients/${id}/`)
    return resp.data
}

export async function postClient(data) {
    const resp = await http.post('/clients/', data)
    return resp.data
}

export async function patchClient(data) {
    const resp = await http.patch(`/clients/${data.id}/`, data)
    return resp.data
}

export async function deleteClient(id) {
    const resp = await http.delete(`/clients/${id}/`)
    return resp.data
}

